import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const createAndUpdateTimelineTasksService = async (
  projectId,
  timelineId,
  { tasksToCreate, tasksToUpdate, tasksToDelete }
) => {
  const apiPath = `timelines/project/${projectId}/timeline/${timelineId}/create-and-update-timeline-tasks`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { tasksToCreate, tasksToUpdate, tasksToDelete },
  });
  const response = await axios(signedRequest);

  return response.data;
};
